(() => {
  'use strict';

  const REVISION = '20260723-welcome-offer-13';
  const runtime = window.TIICHOO_WELCOME_OFFER || {};
  const query = new URLSearchParams(window.location.search);
  const preview = query.get('welcome_offer_preview') === '1';
  const STORAGE_DISMISSED = 'tiichoo_welcome_offer_dismissed_until';
  const STORAGE_JOINED = 'tiichoo_welcome_offer_joined_until';
  const now = Date.now();

  let dynamicWelcomeDiscountApplied = false;
  try {
    const discountCookie = document.cookie
      .split(';')
      .map(part => part.trim())
      .find(part => part.startsWith('discount_code='));
    const discountCode = discountCookie
      ? decodeURIComponent(discountCookie.slice('discount_code='.length))
      : '';
    dynamicWelcomeDiscountApplied = /^[A-Z0-9]{4}(?:-[A-Z0-9]{4}){2}$/i.test(discountCode);
  } catch (_) {}

  // Shopify stores Omnisend's one-time 4-4-4 code in the discount_code
  // cookie before redirecting the shopper to the storefront. This also
  // catches links from emails that were sent before the explicit marker was
  // added. Mark the shopper as joined before any popup can be scheduled.
  if (!preview && (query.get('welcome_offer_claimed') === '1' || dynamicWelcomeDiscountApplied)) {
    try {
      localStorage.setItem(STORAGE_JOINED, String(now + 90 * 86400000));
    } catch (_) {}
    if (query.has('welcome_offer_claimed')) {
      const cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete('welcome_offer_claimed');
      window.history.replaceState(window.history.state, '', `${cleanUrl.pathname}${cleanUrl.search}${cleanUrl.hash}`);
    }
    return;
  }

  const enabled = runtime.enabled === true || preview;
  if (!enabled || runtime.customerKnown === true) return;

  const path = window.location.pathname;
  if (/^\/(cart|checkout|checkouts|account|password)(\/|$)/.test(path)) return;

  const dismissedUntil = Number(localStorage.getItem(STORAGE_DISMISSED) || 0);
  const joinedUntil = Number(localStorage.getItem(STORAGE_JOINED) || 0);
  if (!preview && (dismissedUntil > now || joinedUntil > now)) return;

  const style = document.createElement('style');
  style.dataset.tiichooWelcomeOffer = REVISION;
  style.textContent = `
    .tw-offer-layer,
    .tw-offer-layer * { box-sizing: border-box; }
    .tw-offer-layer .visually-hidden {
      position: absolute !important;
      width: 1px !important;
      height: 1px !important;
      padding: 0 !important;
      margin: -1px !important;
      overflow: hidden !important;
      clip: rect(0, 0, 0, 0) !important;
      white-space: nowrap !important;
      border: 0 !important;
    }
    .tw-offer-layer {
      --tw-navy: #0d3042;
      --tw-teal: #08756f;
      --tw-teal-dark: #075b57;
      --tw-aqua: #eaf5f3;
      --tw-line: #c9dcde;
      --tw-muted: #496570;
      position: fixed;
      inset: 0;
      z-index: 2147483000;
      display: grid;
      place-items: center;
      padding: 24px;
      background: rgba(9, 32, 45, .62);
      font-family: Poppins, Arial, sans-serif;
      opacity: 0;
      visibility: hidden;
      transition: opacity .22s ease, visibility .22s ease;
    }
    .tw-offer-layer.is-open { opacity: 1; visibility: visible; }
    .tw-offer-dialog {
      position: relative;
      width: min(720px, 100%);
      overflow: hidden;
      border: 1px solid rgba(255, 255, 255, .5);
      border-radius: 30px;
      background: #fff;
      color: var(--tw-navy);
      box-shadow: 0 30px 90px rgba(4, 27, 39, .26);
      transform: translateY(18px) scale(.985);
      transition: transform .24s ease;
    }
    .tw-offer-layer.is-open .tw-offer-dialog { transform: translateY(0) scale(1); }
    .tw-offer-close {
      position: absolute;
      top: 17px;
      right: 17px;
      z-index: 2;
      display: grid;
      place-items: center;
      width: 44px;
      height: 44px;
      padding: 0;
      border: 1px solid var(--tw-line);
      border-radius: 50%;
      background: #fff;
      color: var(--tw-navy);
      font: 500 25px/1 Arial, sans-serif;
      cursor: pointer;
    }
    .tw-offer-close:hover { border-color: var(--tw-teal); color: var(--tw-teal); }
    .tw-offer-close:focus-visible,
    .tw-offer-input:focus-visible,
    .tw-offer-submit:focus-visible {
      outline: 3px solid rgba(8, 117, 111, .28);
      outline-offset: 3px;
    }
    .tw-offer-layout { display: grid; grid-template-columns: 220px minmax(0, 1fr); min-height: 430px; }
    .tw-offer-ticket {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      min-width: 0;
      padding: 40px 28px 30px;
      overflow: hidden;
      background: var(--tw-navy);
      color: #fff;
    }
    .tw-offer-ticket::after {
      content: "";
      position: absolute;
      right: -54px;
      bottom: 20px;
      width: 170px;
      height: 170px;
      border: 32px solid rgba(113, 206, 194, .15);
      border-radius: 50%;
    }
    .tw-offer-ticket-label {
      position: relative;
      z-index: 1;
      margin: 0;
      font-size: 12px;
      font-weight: 800;
      line-height: 1.35;
      letter-spacing: .12em;
      text-transform: uppercase;
    }
    .tw-offer-number {
      position: relative;
      z-index: 1;
      display: block;
      margin: auto 0 4px;
      font-size: 78px;
      font-weight: 800;
      line-height: .9;
      letter-spacing: -.075em;
    }
    .tw-offer-ticket strong {
      position: relative;
      z-index: 1;
      display: block;
      max-width: 150px;
      font-size: 22px;
      line-height: 1.18;
      letter-spacing: -.025em;
    }
    .tw-offer-validity {
      position: relative;
      z-index: 1;
      display: inline-flex;
      align-items: center;
      gap: 7px;
      margin-top: 30px;
      font-size: 12px;
      font-weight: 700;
      line-height: 1.4;
    }
    .tw-offer-validity::before {
      content: "";
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background: #78d0c5;
    }
    .tw-offer-content {
      min-width: 0;
      padding: 48px 54px 40px;
    }
    .tw-offer-eyebrow {
      margin: 0 54px 13px 0;
      color: var(--tw-teal);
      font-size: 12px;
      font-weight: 800;
      line-height: 1.35;
      letter-spacing: .11em;
      text-transform: uppercase;
    }
    .tw-offer-title {
      max-width: 390px;
      margin: 0 0 14px;
      color: var(--tw-navy);
      font-size: 38px;
      font-weight: 800;
      line-height: 1.08;
      letter-spacing: -.042em;
    }
    .tw-offer-copy {
      max-width: 390px;
      margin: 0 0 25px;
      color: var(--tw-muted);
      font-size: 15px;
      line-height: 1.62;
    }
    .tw-offer-form { margin: 0; }
    .tw-offer-omnisend [class*="-content"] { max-width: none !important; }
    .tw-offer-omnisend .omnisend-form-6a6207c1f24038a09fbe746f-section-624ab2f927652f651edfd0ac {
      display: none !important;
    }
    .tw-offer-omnisend .omnisend-form-6a6207c1f24038a09fbe746f-section-6374ec98142fd3456c0fb30d {
      padding: 0 !important;
    }
    .tw-offer-omnisend input[type="email"] {
      min-height: 54px !important;
      border: 1px solid var(--tw-line) !important;
      border-radius: 14px !important;
      color: var(--tw-navy) !important;
      font: 500 15px/1.3 Poppins, Arial, sans-serif !important;
    }
    .tw-offer-omnisend button[type="submit"] {
      min-height: 54px !important;
      border: 0 !important;
      border-radius: 14px !important;
      background: var(--tw-teal) !important;
      color: #fff !important;
      font: 700 14px/1.25 Poppins, Arial, sans-serif !important;
    }
    .tw-offer-omnisend button[type="submit"]:hover { background: var(--tw-teal-dark) !important; }
    .tw-offer-field {
      display: grid;
      grid-template-columns: minmax(0, 1fr) auto;
      gap: 9px;
    }
    .tw-offer-input {
      min-width: 0;
      height: 52px;
      padding: 0 17px;
      border: 1px solid var(--tw-line);
      border-radius: 14px;
      background: #fff;
      color: var(--tw-navy);
      font: 500 15px/1.3 Poppins, Arial, sans-serif;
    }
    .tw-offer-input::placeholder { color: #71868e; opacity: 1; }
    .tw-offer-submit {
      min-height: 52px;
      padding: 0 20px;
      border: 1px solid var(--tw-teal);
      border-radius: 14px;
      background: var(--tw-teal);
      color: #fff;
      font: 800 14px/1.25 Poppins, Arial, sans-serif;
      cursor: pointer;
    }
    .tw-offer-submit:hover { border-color: var(--tw-teal-dark); background: var(--tw-teal-dark); }
    .tw-offer-submit:disabled { cursor: wait; opacity: .7; }
    .tw-offer-consent {
      margin: 12px 0 0;
      color: #627780;
      font-size: 10.5px;
      line-height: 1.55;
    }
    .tw-offer-consent a { color: inherit; text-underline-offset: 2px; }
    .tw-offer-error {
      min-height: 20px;
      margin: 8px 0 0;
      color: #a23632;
      font-size: 12px;
      font-weight: 600;
      line-height: 1.45;
    }
    .tw-offer-benefits {
      display: flex;
      flex-wrap: wrap;
      gap: 8px 15px;
      margin: 20px 0 0;
      padding: 18px 0 0;
      border-top: 1px solid var(--tw-line);
      color: var(--tw-navy);
      font-size: 11.5px;
      font-weight: 700;
      line-height: 1.4;
    }
    .tw-offer-benefits span::before { content: "✓"; margin-right: 5px; color: var(--tw-teal); }
    .tw-offer-success {
      display: none;
      padding-top: 18px;
    }
    .tw-offer-dialog.is-success .tw-offer-form,
    .tw-offer-dialog.is-success .tw-offer-copy { display: none; }
    .tw-offer-dialog.is-success .tw-offer-success { display: block; }
    .tw-offer-success strong {
      display: block;
      margin-bottom: 10px;
      font-size: 24px;
      line-height: 1.2;
    }
    .tw-offer-success p {
      margin: 0;
      color: var(--tw-muted);
      font-size: 14px;
      line-height: 1.62;
    }
    .tw-offer-success-note {
      margin-top: 18px !important;
      padding: 14px 16px;
      border: 1px solid var(--tw-line);
      border-radius: 14px;
      background: var(--tw-aqua);
      color: var(--tw-navy) !important;
      font-weight: 700;
    }
    @media (max-width: 640px) {
      .tw-offer-layer { place-items: end center; padding: 0; }
      .tw-offer-dialog {
        width: 100%;
        max-height: min(92vh, 760px);
        overflow-y: auto;
        border-width: 1px 0 0;
        border-radius: 28px 28px 0 0;
        transform: translateY(30px);
      }
      .tw-offer-layout { display: block; min-height: 0; }
      .tw-offer-ticket {
        display: grid;
        grid-template-columns: auto 1fr;
        align-items: center;
        gap: 8px 17px;
        min-height: 118px;
        padding: 24px 72px 22px 22px;
      }
      .tw-offer-ticket::after { right: -44px; bottom: -78px; width: 160px; height: 160px; }
      .tw-offer-ticket-label { grid-column: 1 / -1; font-size: 10.5px; }
      .tw-offer-number { grid-row: 2 / 4; margin: 0; font-size: 58px; }
      .tw-offer-ticket strong { max-width: 170px; font-size: 17px; }
      .tw-offer-validity { margin: 2px 0 0; font-size: 10.5px; }
      .tw-offer-close { top: 18px; right: 17px; border-color: rgba(255, 255, 255, .48); background: rgba(255, 255, 255, .12); color: #fff; }
      .tw-offer-content { padding: 27px 20px max(26px, env(safe-area-inset-bottom)); }
      .tw-offer-eyebrow { margin: 0 0 9px; font-size: 10.5px; }
      .tw-offer-title { margin-bottom: 11px; font-size: 31px; line-height: 1.1; }
      .tw-offer-copy { margin-bottom: 20px; font-size: 14.5px; line-height: 1.58; }
      .tw-offer-field { grid-template-columns: 1fr; gap: 9px; }
      .tw-offer-input,
      .tw-offer-submit { width: 100%; min-height: 50px; }
      .tw-offer-submit { font-size: 14.5px; }
      .tw-offer-benefits { margin-top: 16px; padding-top: 15px; font-size: 11px; }
    }
    @media (prefers-reduced-motion: reduce) {
      .tw-offer-layer,
      .tw-offer-dialog { transition: none; }
    }
  `;

  const layer = document.createElement('div');
  layer.className = 'tw-offer-layer';
  layer.dataset.revision = REVISION;
  layer.setAttribute('aria-hidden', 'true');
  layer.innerHTML = `
    <section class="tw-offer-dialog" role="dialog" aria-modal="true" aria-labelledby="tw-offer-title" aria-describedby="tw-offer-copy">
      <button class="tw-offer-close" type="button" aria-label="Close welcome offer">×</button>
      <div class="tw-offer-layout">
        <aside class="tw-offer-ticket" aria-label="15% welcome discount">
          <p class="tw-offer-ticket-label">New subscriber offer</p>
          <span class="tw-offer-number">15%</span>
          <strong>off your first order</strong>
          <span class="tw-offer-validity">Your code lasts 7 days</span>
        </aside>
        <div class="tw-offer-content">
          <p class="tw-offer-eyebrow">A better first order</p>
          <h2 class="tw-offer-title" id="tw-offer-title">Get 15% off your first TIICHOO order</h2>
          <p class="tw-offer-copy" id="tw-offer-copy">Enter your email and we’ll send a one-time 15% code for any TIICHOO product.</p>
          <div class="tw-offer-form tw-offer-omnisend">
            <div id="omnisend-embedded-v2-6a6207c1f24038a09fbe746f"></div>
          </div>
          <p class="tw-offer-consent">By signing up, you agree to receive TIICHOO marketing emails. One use per customer; cannot be combined with other offers. Unsubscribe anytime. See our <a href="/policies/privacy-policy">Privacy Policy</a>.</p>
          <div class="tw-offer-success" role="status" aria-live="polite">
            <strong>Check your inbox.</strong>
            <p>Your personal 15% code is on its way.</p>
            <p class="tw-offer-success-note">One use · All products · Valid for 7 days</p>
          </div>
          <div class="tw-offer-benefits" aria-label="Offer terms">
            <span>All products</span>
            <span>One-time use</span>
            <span>Discreet shipping</span>
          </div>
        </div>
      </div>
    </section>
  `;

  const dialog = layer.querySelector('.tw-offer-dialog');
  const closeButton = layer.querySelector('.tw-offer-close');
  let lastFocus = null;
  let opened = false;
  let mounted = false;
  let omnisendObserver = null;

  function tuneOmnisendForm() {
    const root = layer.querySelector('#omnisend-form-6a6207c1f24038a09fbe746f');
    if (!root) return;
    const emailField = root.querySelector('input[type="email"]');
    const submit = root.querySelector('button[type="submit"]');
    if (emailField && emailField.placeholder !== 'Email address') emailField.placeholder = 'Email address';
    if (submit && submit.textContent.trim() !== 'Email my 15% code') submit.textContent = 'Email my 15% code';
  }

  omnisendObserver = new MutationObserver(tuneOmnisendForm);
  omnisendObserver.observe(layer, { childList: true, subtree: true });

  function isVisible(element) {
    if (!element) return false;
    const rect = element.getBoundingClientRect();
    const styleValue = getComputedStyle(element);
    if (typeof element.checkVisibility === 'function' && !element.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true })) return false;
    return rect.width > 0 &&
      rect.height > 0 &&
      styleValue.visibility !== 'hidden' &&
      styleValue.display !== 'none' &&
      Number(styleValue.opacity || 1) > 0;
  }

  function hasCompetingOverlay() {
    const selectors = [
      '#pandectes-banner',
      '[role="dialog"][aria-modal="true"]',
      '.quick-layer.is-open',
      '.quick-add-drawer.is-open',
      '[class*="omnisend"][class*="open"]',
      'iframe[src*="soundest"]',
      'iframe[src*="omnisend"]'
    ];
    if (selectors.some(selector => Array.from(document.querySelectorAll(selector)).some(node => node !== dialog && !layer.contains(node) && isVisible(node)))) return true;
    return Array.from(document.querySelectorAll('*')).some(host => {
      const root = host.shadowRoot;
      if (!root) return false;
      return Array.from(root.querySelectorAll('[role="dialog"][aria-modal="true"], .quick-layer.is-open, .quick-add-drawer.is-open')).some(isVisible);
    });
  }

  function remember(key, days) {
    try {
      localStorage.setItem(key, String(Date.now() + days * 86400000));
    } catch (_) {}
  }

  function prepareOffer() {
    if (mounted) return;
    mounted = true;
    document.documentElement.append(style, layer);
    tuneOmnisendForm();
  }

  function omnisendFormReady() {
    tuneOmnisendForm();
    const emailField = layer.querySelector('#omnisend-form-6a6207c1f24038a09fbe746f input[type="email"]');
    const submit = layer.querySelector('#omnisend-form-6a6207c1f24038a09fbe746f button[type="submit"]');
    return Boolean(emailField && submit);
  }

  function openOffer() {
    prepareOffer();
    if (opened || !omnisendFormReady() || hasCompetingOverlay()) return false;
    opened = true;
    lastFocus = document.activeElement;
    requestAnimationFrame(() => {
      layer.classList.add('is-open');
      layer.setAttribute('aria-hidden', 'false');
      setTimeout(() => {
        tuneOmnisendForm();
        const emailField = layer.querySelector('input[type="email"]');
        if (emailField) emailField.focus({ preventScroll: true });
      }, 500);
    });
    return true;
  }

  function closeOffer(reason = 'dismissed') {
    if (!opened) return;
    layer.classList.remove('is-open');
    layer.setAttribute('aria-hidden', 'true');
    if (reason === 'dismissed' && !preview) remember(STORAGE_DISMISSED, 14);
    setTimeout(() => {
      layer.remove();
      style.remove();
      mounted = false;
      if (omnisendObserver) omnisendObserver.disconnect();
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
    }, 240);
  }

  function scheduleOpen() {
    const delay = 6000;
    let elapsed = false;
    let scrolled = false;
    let retries = 0;

    // Mount the hidden shell immediately so Omnisend can render while the
    // shopper is browsing. The popup is never made visible until both the
    // email field and submit button are present.
    prepareOffer();

    const tryOpen = () => {
      if (!(elapsed && scrolled) && !preview) return;
      if (openOffer()) {
        window.removeEventListener('scroll', onScroll);
        return;
      }
      if (retries < 12) {
        retries += 1;
        setTimeout(tryOpen, 1500);
      } else if (!opened) {
        // If a privacy setting, content blocker, or slow connection prevents
        // Omnisend from loading, remove the hidden shell instead of showing a
        // broken offer without an email field.
        layer.remove();
        style.remove();
        mounted = false;
        if (omnisendObserver) omnisendObserver.disconnect();
      }
    };

    const onScroll = () => {
      scrolled = true;
      tryOpen();
    };

    if (preview) {
      elapsed = true;
      scrolled = true;
      setTimeout(tryOpen, 180);
      return;
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    setTimeout(() => {
      elapsed = true;
      scrolled = true;
      tryOpen();
    }, delay);
  }

  closeButton.addEventListener('click', () => closeOffer('dismissed'));
  layer.addEventListener('click', event => {
    if (event.target === layer) closeOffer('dismissed');
  });
  document.addEventListener('keydown', event => {
    if (!opened) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeOffer('dismissed');
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = Array.from(dialog.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href]')).filter(isVisible);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  window.addEventListener('omnisendForms', event => {
    const detail = event.detail || {};
    const eventName = detail.eventName || detail.type;
    const formID = detail.form?.id || detail.form?.ID;
    if (formID !== '6a6207c1f24038a09fbe746f' || !['submit', 'stepSubmit'].includes(eventName)) return;
    remember(STORAGE_JOINED, 90);
    dialog.classList.add('is-success');
    closeButton.focus({ preventScroll: true });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleOpen, { once: true });
  } else {
    scheduleOpen();
  }
})();
